import type { Locale } from "date-fns";
import { de, enGB, fr } from "date-fns/locale";
import { z } from "zod";
import type { IsoLanguageCode } from "./IsoLanguages";

export const defaultServiceLanguage = "en";
export const AdditionalServiceLanguage = z.enum(["de", "fr"]);

export const ServiceLanguage = z.enum([
    ...AdditionalServiceLanguage.options,
    defaultServiceLanguage,
]);

export type AdditionalServiceLanguage = z.infer<typeof AdditionalServiceLanguage>;

export type ServiceLanguage = z.infer<typeof ServiceLanguage>;

export const ServiceLanguageMap: Record<ServiceLanguage, string> = {
    en: "English",
    de: "German",
    fr: "French",
};

export const ServiceLanguageToLocaleMap: Record<ServiceLanguage, Locale> = {
    en: enGB,
    de,
    fr,
};

export const ServiceLanguageToIsoLanguageCodeMap: Record<
    ServiceLanguage,
    IsoLanguageCode
> = {
    en: "en",
    de: "de",
    fr: "fr",
};

export function getLocale(possibleLocale: string | undefined | null): ServiceLanguage {
    const parsed = ServiceLanguage.safeParse(possibleLocale);

    if (parsed.success) {
        return parsed.data;
    }
    return defaultServiceLanguage;
}
